const buildCategoryTreeIndex = trees => {
    const ancestorsById = {}
    const descendantsById = {}
    const visit = (node, ancestors = []) => {
        if (!node || !node.id) {
            return
        }

        const id = Number(node.id)
        ancestorsById[id] = ancestors
        ancestors.forEach(ancestorId => {
            if (!descendantsById[ancestorId]) {
                descendantsById[ancestorId] = []
            }
            descendantsById[ancestorId].push(id)
        })

        const children = node.children || []
        children.forEach(child => visit(child, ancestors.concat([id])))
    }

    const roots = trees || []
    roots.forEach(node => visit(node))

    return { ancestorsById, descendantsById }
}

const buildSubstanceListVisibilityProductContext = (
    product = {},
    materialCategoryTrees = [],
    mixtureCategoryTrees = [],
) => ({
    regulatedProductStatements: product.regulatedProductStatements || [],
    materialCategoryIds: product.materialCategoryIds || [],
    mixtureCategoryIds: product.mixtureCategoryIds || [],
    materialCategoryRelations: buildCategoryTreeIndex(materialCategoryTrees),
    mixtureCategoryRelations: buildCategoryTreeIndex(mixtureCategoryTrees),
})

export {
    buildCategoryTreeIndex,
    buildSubstanceListVisibilityProductContext,
}
